import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6b7e209d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "text-black"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "text-center py-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "fa fa-spinner fa-spin" }, null, -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading, please wait ...", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_14 = { class: "text-center py-4" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["src", "onError"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_19 = { style: {"font-size":"16px","text-align":"center"} }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["src", "onError"]
const _hoisted_22 = {
  key: 3,
  style: {"font-size":"16px","color":"black !important"},
  class: "font-normal"
}
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "fa fa-spinner fa-spin" }, null, -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading, please wait ...", -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_28 = {
  key: 0,
  class: "text-center"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["href"]

import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import crApi from "../service/CrApi";
import securityService from "../service/SecurityService";
import flashMessenger from '../service/FlashMessenger';
import asset from '../service/AssetService';
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScanCardComponent',
  props: {
  scan: {
    type: Object,
    required: true
  },
  received: {
    type: [String, Number],
    default: null
  },
  scanFilterStateV2: Object,
},
  setup(__props) {

const props = __props;

const isDisabled = ref(false);
const route = useRoute();
const isPreview = ref(false);
const receivedTimestamp = ref(null);
const isLoadingResults = ref(true);
const scanQuestions = ref([]);
const scanProperties = ref([]);
const showQuestions = ref(false);
const showProperties = ref(false);
const isPostbackDone = ref(false);
const isEmergencyScan = ref(false);
const scan = ref(props.scan);
const isLoadingQuestions = ref(false);
const isLoadedQuestions = ref(false);
const isDeleteScanModalOpen = ref(false);
const deletingScanId  = ref(null);
const isLoadingProperties = ref(false);
const isLoadedProperties = ref(false);
const modifiedTimestamp = ref(null);
const bothTimestamp = ref(null);
const currentStates = ref(['account.scans.search', 'account.scans.search.list', 'account.scans.uploads', 'account.scans.bulk_scan_removal']);
const currentState = ref(route.name as string);
const panel = ref([]);
const router = ref(useRouter());

onMounted(() => {
  isPreview.value = route.query.preview !== undefined;
  receivedTimestamp.value = parseInt(props.received as string) == 1;
  modifiedTimestamp.value = parseInt(props.received as string) == 2;
  bothTimestamp.value = parseInt(props.received as string) == 3;

  checkPostback();
  if (currentStates.value.indexOf(currentState.value) == -1) {
    currentState.value = 'account.scans.search.list';
  }
  if (scan.value.scanResponse === null) {
    scan.value.scanResponse = '';
  }
  if (scan.value.scanResponse.substr(0, 6) == "<curl>" && scan.value.scanResponse.substr(-7) == "</curl>") {
    scan.value.scanResponse = scan.value.scanResponse.substr(6, scan.value.scanResponse.length - 7 - 6);
    scan.value.resultType = 'curl';
  } else if ((scan.value.scanResponse.substr(0, 6) == "<html>" && scan.value.scanResponse.substr(-7) == "</html>") ||
      (scan.value.scanResponse.indexOf("<html>") != -1  && scan.value.scanResponse.indexOf("</html>") != -1)) {
    scan.value.scanResponse = encodeURIComponent(scan.value.scanResponse);
    scan.value.resultType = 'html';
  }
  detectEmergencyScan();

  isLoadingResults.value = false;
});

async function deleteScan () {
  if (isDisabled.value) {
    return;
  }
  isDisabled.value = true;
  let response = await crApi.requestV2('scan/delete/',{
    scanId: deletingScanId.value,
    website_token: securityService.getToken()
  });
  props.scanFilterStateV2.deletingScan = true;
  await props.scanFilterStateV2.loadScans();
  if (response.status == 1) {
    await flashMessenger.toastById('SAN_DELETED', 'success');
  } else {
    await flashMessenger.toastById(response.error, 'danger');
  }
  isDeleteScanModalOpen.value = false;
  deletingScanId.value = null;
  isDisabled.value = false;
}

async function checkPostback() {
  let pbProperty = await crApi.requestV2('scan_property/retrieve_scan_property/', {
    website_token: securityService.getToken(),
    scanId: scan.value.scanId,
    propertyName: 'successful_postback_url',
    response: 'extra'
  });
  if (pbProperty.status == 1) {
    isPostbackDone.value = true;
  } else {
    let failedPostbackAttempt = await crApi.requestV2('scan_property/retrieve_scan_property/', {
      website_token: securityService.getToken(),
      scanId: scan.value.scanId,
      propertyName: 'failed_postback_attempts',
      response: 'extra'
    });
    if (failedPostbackAttempt.status == 1) {
      isPostbackDone.value = true;
    }
  }
}

function detectEmergencyScan() {
  if (props.scan && props.scan.properties) {
    isEmergencyScan.value = props.scan.properties.some(prop => prop.emergency_mode === 1);
  }
}

const processAnswerText = (text: any) => {
  if (text.startsWith('geo://')) {
    const t = text.substr(6).split(',');
    return { type: 'geo', answerText: `${t[0]},${t[1]}`, link: '', thumbimg: '', file: '' };
  } else if (text.startsWith('<dropbox')) {
    const textCleaned = text.replace(/\\/g, ' ');
    const existLink = /link="([^"]+)"/.exec(textCleaned);
    const existFile = /file="([^"]+)"/.exec(textCleaned);
    return { type: 'dropbox', link: existLink ? existLink[1] : '', thumbimg: existLink ? existLink[1] : '', file: existFile ? existFile[1] : '' };
  } else if (text.startsWith('data:image/png;base64')) {
    const cleanedText = text.replace(/\\/g, ' ');
    return { type: 'base64', answerText: cleanedText, thumbimg: cleanedText, file: '' };
  } else if (text.startsWith('{')) {
    try {
      const answers = JSON.parse(text);
      return { type: 'json', link: answers.link, thumbimg: answers.link, file: answers.filename };
    } catch (e) {
      console.error('Error parsing JSON answer', e);
      return { type: '', answerText: text, link: '', thumbimg: '', file: '' };
    }
  } else {
    return { type: '', answerText: text, link: '', thumbimg: '', file: '' };
  }
};

const loadQuestions = async (scanId: any) => {
  if (!isLoadedQuestions.value) {
    isLoadingQuestions.value = true;
    const scanResponse = await crApi.requestV2('scan/retrieve_question/', {
      scanId: scanId,
      website_token: securityService.getToken()
    });
    if (scanResponse.status === 1) {
      isLoadedQuestions.value = true;
      scanQuestions.value = scanResponse.question.map(question => ({
        ...question,
        answer: question.answer.map(answer => {
          const processedAnswer = processAnswerText(answer.answerText);
          return {
            ...answer,
            ...processedAnswer
          };
        })
      }));
    }
    isLoadingQuestions.value = false;
  }
};

const loadProperties = async (scanId: any) => {
  if (!isLoadedProperties.value) {
    isLoadingProperties.value = true;
    try {
      const scanResponse = await crApi.requestV2('scan/retrieve_property/', {
        scanId: scanId,
        website_token: securityService.getToken()
      });
      if (scanResponse.status === 1) {
        isLoadedProperties.value = true;
        scanProperties.value = scanResponse.property.map(property => {
          let modifiedValue = '';
          let type = '';
          if (property.value && property.value.startsWith('geo://')) {
            const [lat, lng] = property.value.substr(6).split(',');
            modifiedValue = `${lat},${lng}`;
            type = 'geo';
          }
          return { ...property, type, modifiedValue };
        });
      }
    } catch (error) {
      console.error('Failed to load properties:', error);
    } finally {
      isLoadingProperties.value = false;
    }
  }
};

function imageError (answer: any) {
  answer.thumbimg = asset('icon/image_cancel_32.png');
}

function getDate(date, format) {
  if (!date) {
    return null;
  }
  let dt = date.replace('T',' ');
  let res = dt.slice(0, 19);
  return moment(res).format(format);
}

function decodeURI(uri) {
  return decodeURIComponent(uri);
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      class: "mb-4 elevation-0 rounded-lg",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            (!isLoadingResults.value)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  align: "start",
                  class: "mb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "8",
                      class: "text-start"
                    }, {
                      default: _withCtx(() => [
                        (!isLoadingResults.value)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    (scan.value.scanStatus === -1)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _unref(asset)('icon/saved.png'),
                                          alt: "Saved on-device and uploaded without validation."
                                        }, null, 8 /* PROPS */, _hoisted_1))
                                      : _createCommentVNode("v-if", true),
                                    (scan.value.scanStatus === 0)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: _unref(asset)('icon/invalid.png'),
                                          alt: "Invalid / duplicate scan."
                                        }, null, 8 /* PROPS */, _hoisted_2))
                                      : _createCommentVNode("v-if", true),
                                    (scan.value.scanStatus === 1)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 2,
                                          src: _unref(asset)('icon/valid.png'),
                                          alt: "Recorded / valid scan."
                                        }, null, 8 /* PROPS */, _hoisted_3))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "10" }, {
                                  default: _withCtx(() => [
                                    (scan.value.scanValue.length > 0)
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_4, [
                                          _createTextVNode(_toDisplayString(scan.value['scanValue'].length > 100 ? scan.value['scanValue'].substr(0, 99) + '...' : scan.value['scanValue']) + " ", 1 /* TEXT */),
                                          _createVNode(_component_v_tooltip, {
                                            activator: "parent",
                                            location: "bottom",
                                            "max-width": "400"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(scan.value['scanValue'] ? scan.value['scanValue'] : ''), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                          })
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (scan.value.resultType === 'curl')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                          _createVNode(_component_v_btn, {
                                            variant: "text",
                                            href: scan.value.scanResponse,
                                            target: "_blank"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("See Response "),
                                              _createVNode(_component_v_icon, { small: "" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("open_in_new")
                                                ]),
                                                _: 1 /* STABLE */
                                              })
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 8 /* PROPS */, ["href"])
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (scan.value.resultType === 'html')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                          _createVNode(_component_v_btn, {
                                            variant: "text",
                                            to: { name: 'app.scanresponse', params:{scanId: scan.value.scanId}}
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("See HTML Response "),
                                              _createVNode(_component_v_icon, { small: "" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("open_in_new")
                                                ]),
                                                _: 1 /* STABLE */
                                              })
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 8 /* PROPS */, ["to"]),
                                          _createVNode(_component_v_tooltip, {
                                            activator: "parent",
                                            location: "bottom",
                                            "max-width": "400"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(decodeURI(scan.value.scanResponse)), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                          })
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (scan.value.resultType == undefined && scan.value.scanResponse && scan.value.scanResponse.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                          _createElementVNode("span", null, _toDisplayString(scan.value['scanResponse'].length > 250 ? scan.value['scanResponse'].substr(0, 249) + '...' : scan.value['scanResponse']), 1 /* TEXT */),
                                          _createVNode(_component_v_tooltip, {
                                            activator: "parent",
                                            location: "bottom",
                                            "max-width": "400"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(scan.value['scanResponse'] ? scan.value['scanResponse'] : ''), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                          })
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (isEmergencyScan.value)
                                      ? (_openBlock(), _createBlock(_component_v_chip, {
                                          key: 4,
                                          color: "red",
                                          size: "small",
                                          "append-icon": "mdi-alert-circle-outline",
                                          class: "mt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Emergency scan ")
                                          ]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "text-right"
                    }, {
                      default: _withCtx(() => [
                        (isPreview.value && scan.value.service._validationMethod !== 'databasebuilder')
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              variant: "text",
                              class: "text-none",
                              "append-icon": "mdi-pencil",
                              to: {name: 'account.scans.edit', query: {scanId: scan.value.scanId}}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Edit")
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["to"]))
                          : _createCommentVNode("v-if", true),
                        (!scan.value.isActive)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              class: "text-none",
                              variant: "text",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => {deletingScanId.value = scan.value.scanId; isDeleteScanModalOpen.value = true}),
                              "append-icon": "mdi-delete",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Delete")
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scan.value.type === 'checkinout' ? 'Check In/Out' : 'Table Builder'), 1 /* TEXT */))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_expansion_panels, {
              modelValue: panel.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((panel).value = $event)),
              variant: "accordion",
              multiple: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (loadQuestions(scan.value.scanId))),
                  class: _normalizeClass({ 'bg-indigo-lighten-4 my-1 border': panel.value.includes(0), 'rounded': true }),
                  elevation: "0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, {
                      class: "font-weight-bold px-0 my-n4 text-body-2",
                      "hide-actions": ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'bg-indigo-lighten-4 w-100 pa-2 rounded font-weight-bold text-subtitle-1': true, 'border': !panel.value.includes(0)})
                        }, [
                          _createVNode(_component_v_icon, {
                            class: "mt-n1",
                            size: "large",
                            icon: panel.value.includes(0) ? 'mdi-menu-down' : 'mdi-menu-right'
                          }, null, 8 /* PROPS */, ["icon"]),
                          _createTextVNode(" Questions ")
                        ], 2 /* CLASS */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_expansion_panel_text, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("h4", _hoisted_9, [
                          _hoisted_10,
                          _createTextVNode(),
                          _hoisted_11,
                          _hoisted_12,
                          _hoisted_13
                        ], 512 /* NEED_PATCH */), [
                          [_vShow, isLoadingQuestions.value]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_14, "No Questions", 512 /* NEED_PATCH */), [
                          [_vShow, scanQuestions.value.length == 0 && !isLoadingQuestions.value]
                        ]),
                        (!isLoadingQuestions.value)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(scanQuestions.value, (question) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, { class: "py-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("strong", null, _toDisplayString(question['questionText']), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answer, (answer) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item_subtitle, { class: "mt-1" }, {
                                      default: _withCtx(() => [
                                        (answer.type == 'geo')
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              style: {"font-size":"16px","color":"black"},
                                              href: 'https://maps.google.com?q=' + answer.answerText,
                                              target: "_blank"
                                            }, _toDisplayString(answer.answerText), 9 /* TEXT, PROPS */, _hoisted_15))
                                          : _createCommentVNode("v-if", true),
                                        ((answer.type == 'dropbox' || answer.type == 'json') && answer.link != '')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("a", {
                                                href: answer.link,
                                                target: "_blank"
                                              }, [
                                                _createElementVNode("img", {
                                                  style: {"max-width":"180px","margin":"auto","display":"block"},
                                                  src: answer.thumbimg,
                                                  class: "maxWDropbox img-thumbnail",
                                                  onError: ($event: any) => {imageError(answer);},
                                                  alt: "max dropbox"
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_17)
                                              ], 8 /* PROPS */, _hoisted_16),
                                              _hoisted_18,
                                              _createElementVNode("div", _hoisted_19, _toDisplayString(answer.file), 1 /* TEXT */)
                                            ], 64 /* STABLE_FRAGMENT */))
                                          : _createCommentVNode("v-if", true),
                                        (answer.type == 'base64')
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 2,
                                              href: answer.answerText,
                                              target: "_blank"
                                            }, [
                                              _createElementVNode("img", {
                                                src: answer.thumbimg,
                                                class: "maxWBase64 img-thumbnail",
                                                onError: ($event: any) => {imageError(answer);},
                                                alt: "max Wbase"
                                              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_21)
                                            ], 8 /* PROPS */, _hoisted_20))
                                          : _createCommentVNode("v-if", true),
                                        (answer.type == '')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(answer.answerText), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */))
                                  }), 256 /* UNKEYED_FRAGMENT */))
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class"]),
                _createVNode(_component_v_expansion_panel, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (loadProperties(scan.value.scanId))),
                  class: _normalizeClass({ 'bg-indigo-lighten-4 my-1 border': panel.value.includes(1), 'rounded': true }),
                  elevation: "0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, {
                      class: "font-weight-bold px-0 my-n3 text-body-2",
                      "hide-actions": ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'bg-indigo-lighten-4 w-100 pa-2 rounded font-weight-bold text-subtitle-1': true, 'border': !panel.value.includes(1)})
                        }, [
                          _createVNode(_component_v_icon, {
                            class: "mt-n1",
                            size: "large",
                            icon: panel.value.includes(1) ? 'mdi-menu-down' : 'mdi-menu-right'
                          }, null, 8 /* PROPS */, ["icon"]),
                          _createTextVNode(" Properties ")
                        ], 2 /* CLASS */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_expansion_panel_text, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("h4", _hoisted_23, [
                          _hoisted_24,
                          _createTextVNode(),
                          _hoisted_25,
                          _hoisted_26,
                          _hoisted_27
                        ], 512 /* NEED_PATCH */), [
                          [_vShow, isLoadingProperties.value]
                        ]),
                        (scanProperties.value.length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, "No Properties"))
                          : _createCommentVNode("v-if", true),
                        (!isLoadingProperties.value)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(scanProperties.value, (property) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("strong", null, _toDisplayString(property['friendlyName'] != '' ? property['friendlyName'] : property.name), 1 /* TEXT */),
                                      _createTextVNode(": " + _toDisplayString(property.type != undefined &&  property.type == 'geo' ? property['modifiedValue']  : property.value) + " ", 1 /* TEXT */),
                                      (property.type == 'geo')
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_29, [
                                            _createElementVNode("a", {
                                              href: 'https://maps.google.com?q=' + property.modifiedValue,
                                              target: "_blank"
                                            }, [
                                              _createVNode(_component_v_icon, { icon: "mdi-link" })
                                            ], 8 /* PROPS */, _hoisted_30)
                                          ]))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_card_actions, { class: "justify-space-around d-block border bg-grey-lighten-3 rounded mx-4 mt-n3 mb-2" }, {
          default: _withCtx(() => [
            (!receivedTimestamp.value && !modifiedTimestamp.value && !bothTimestamp.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "text-subtitle d-inline-block mx-4 hover-styling",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (router.value.push({name: _unref(route).name, query: {start_date: getDate(scan.value.timestamp.scannedTimestamp, 'YYYY-MM-DD'), end_date: getDate(scan.value.timestamp.scannedTimestamp, 'YYYY-MM-DD')}})))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "mt-n1",
                    icon: "mdi-clock-time-four-outline"
                  }),
                  _createTextVNode(" Scanned @ " + _toDisplayString(getDate(scan.value.timestamp.scannedTimestamp, 'MMM DD, YYYY h:mm A')) + " ", 1 /* TEXT */),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Only show scans made on " + _toDisplayString(getDate(scan.value.timestamp.scannedTimestamp, 'MMM DD, YYYY')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true),
            (receivedTimestamp.value && scan.value.timestamp.receivedTimestamp !== undefined && !bothTimestamp.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "text-subtitle d-inline-block mx-4 hover-styling",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (router.value.push({ name: _unref(route).name, query: { start_date: getDate(scan.value.timestamp.receivedTimestamp, 'YYYY-MM-DD'), end_date: getDate(scan.value.timestamp.receivedTimestamp, 'YYYY-MM-DD') }})))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "mt-n1",
                    size: "small",
                    icon: "mdi-clock-time-four-outline"
                  }),
                  _createTextVNode(" Received @ " + _toDisplayString(getDate(scan.value.timestamp.receivedTimestamp, 'MMM DD, YYYY h:mm A')) + " ", 1 /* TEXT */),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Only show scans made on " + _toDisplayString(getDate(scan.value.timestamp.receivedTimestamp, 'MMM DD, YYYY')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true),
            (modifiedTimestamp.value && scan.value.timestamp.modifiedTimestamp !== undefined && !bothTimestamp.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "text-subtitle d-inline-block mx-4 hover-styling",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (router.value.push({name: _unref(route).name, query: {start_date: getDate(scan.value.timestamp.modifiedTimestamp, 'YYYY-MM-DD'), end_date: getDate(scan.value.timestamp.modifiedTimestamp, 'YYYY-MM-DD')}})))
                }, [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    class: "mt-n1",
                    icon: "mdi-clock-time-four-outline"
                  }),
                  _createTextVNode("Modified @ " + _toDisplayString(getDate(scan.value.timestamp.modifiedTimestamp, 'MMM DD, YYYY h:mm A')) + " ", 1 /* TEXT */),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Only show scans made on " + _toDisplayString(getDate(scan.value.timestamp.modifiedTimestamp, 'MMM DD, YYYY')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true),
            (bothTimestamp.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "text-subtitle d-inline-block mx-4 hover-styling",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (scan.value.timestamp.modifiedTimestamp ? router.value.push({name: _unref(route).name, query: {start_date: getDate(scan.value.timestamp.modifiedTimestamp, 'YYYY-MM-DD'), end_date: getDate(scan.value.timestamp.modifiedTimestamp, 'YYYY-MM-DD')}}) : router.value.push({name: _unref(route).name, query: {start_date: getDate(scan.value.timestamp.receivedTimestamp, 'YYYY-MM-DD'), end_date: getDate(scan.value.timestamp.receivedTimestamp, 'YYYY-MM-DD')}})))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "mt-n1",
                    size: "small",
                    icon: "mdi-clock-time-four-outline"
                  }),
                  _createTextVNode(" " + _toDisplayString(scan.value.timestamp.modifiedTimestamp ? 'Modified' : 'Received') + " @ " + _toDisplayString(scan.value.timestamp.modifiedTimestamp ? getDate(scan.value.timestamp.modifiedTimestamp, 'MMM DD, YYYY h:mm A') : getDate(scan.value.timestamp.receivedTimestamp, 'MMM DD, YYYY h:mm A')) + " ", 1 /* TEXT */),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Only show scans made on " + _toDisplayString(scan.value.timestamp.modifiedTimestamp ? getDate(scan.value.timestamp.modifiedTimestamp, 'MMM DD, YYYY') : getDate(scan.value.timestamp.receivedTimestamp, 'MMM DD, YYYY')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
              class: "text-subtitle d-inline-block mx-4 hover-styling",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (router.value.push({name: _unref(route).name, query: {service_ids: scan.value.service.serviceId, period: 'all'}})))
            }, [
              _createVNode(_component_v_icon, {
                class: "mt-n1",
                size: "small",
                icon: "mdi-file"
              }),
              _createTextVNode(" " + _toDisplayString(scan.value.service.name) + " ", 1 /* TEXT */),
              _createVNode(_component_v_tooltip, {
                activator: "parent",
                location: "bottom"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Only show scans made with " + _toDisplayString(scan.value.service.name), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createElementVNode("div", {
              class: "text-subtitle d-inline-block mx-4 hover-styling",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (router.value.push({name: _unref(route).name, query: {device_ids: scan.value.device.deviceId, period: 'all'}})))
            }, [
              _createVNode(_component_v_icon, {
                class: "mt-n1",
                size: "small",
                icon: "mdi-cellphone"
              }),
              _createTextVNode(" " + _toDisplayString(scan.value.device.name) + " ", 1 /* TEXT */),
              _createVNode(_component_v_tooltip, {
                activator: "parent",
                location: "bottom"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Only show scans made using " + _toDisplayString(scan.value.device.name), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createElementVNode("div", {
              class: "text-subtitle d-inline-block mx-4 hover-styling",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (router.value.push({name: _unref(route).name, query: {user_ids: scan.value.createdUser.userId, u_deleted: 0, period: 'all'}})))
            }, [
              _createVNode(_component_v_icon, {
                size: "small",
                class: "mt-n1",
                icon: "mdi-account"
              }),
              _createTextVNode(" " + _toDisplayString(scan.value.createdUser.username) + " ", 1 /* TEXT */),
              _createVNode(_component_v_tooltip, {
                activator: "parent",
                location: "bottom"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Only show scans made by " + _toDisplayString(scan.value.createdUser.username), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createElementVNode("div", {
              class: "text-subtitle d-inline-block mx-4 hover-styling",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (router.value.push({name: _unref(route).name, query: {scan_ids: scan.value.scanId, period: 'all' }})))
            }, [
              _createVNode(_component_v_icon, {
                class: "mt-n1",
                size: "small",
                icon: "mdi-file"
              }),
              _createTextVNode(" Scan ID " + _toDisplayString(scan.value.scanId) + " ", 1 /* TEXT */),
              _createVNode(_component_v_tooltip, {
                activator: "parent",
                location: "bottom"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Only show this " + _toDisplayString(scan.value.scanId) + " scan ", 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            (isPostbackDone.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "text-subtitle d-inline-block mx-4 hover-styling",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (router.value.push({name: 'account.externalaccount.postback', query: { scanId: scan.value.scanId }})))
                }, [
                  _createVNode(_component_v_icon, {
                    class: "mt-n1",
                    size: "small",
                    icon: "mdi-share"
                  }),
                  _createTextVNode(" Postback Log "),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" View Postback Log of this scan")
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_v_dialog, {
      modelValue: isDeleteScanModalOpen.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((isDeleteScanModalOpen).value = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { text: "Are you sure you want to delete this scan? You will not be able to undo this action." }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "Yes",
                  onClick: deleteScan,
                  disabled: isDisabled.value,
                  variant: "tonal"
                }, null, 8 /* PROPS */, ["disabled"]),
                _createVNode(_component_v_btn, {
                  text: "Cancel",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (isDeleteScanModalOpen.value = false)),
                  disabled: isDisabled.value,
                  color: "black",
                  variant: "elevated"
                }, null, 8 /* PROPS */, ["disabled"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})